<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (!editMode) {
      <span>{{ 'components.decision-table.show-decision-table.add-invite-page' | translate }}</span>
    }
    @if (editMode) {
      <span>{{ 'components.decision-table.show-decision-table.invitation-page-details' | translate }}</span>
    }
    <span class="modal-toolbar-spacer"></span>
    <button mat-icon-button class="ml-auto close-toolbar-btn" (click)="closeDialogue()"
      [matTooltip]="'generic.buttons.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>

@if (loading) {
  <div class="row">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
}

<div class="container">
  <form [formGroup]="addInvitationPageForm" (ngSubmit)="onSubmit()" novalidate>
    <mat-card class="w-75 my-5 ml-auto mr-auto">
      <mat-card-content>

        <mat-form-field class="full-width">
          <mat-label>{{ "components.decision-table.new-decision-table.compile-proposal.title" | translate }}</mat-label>
          <input matInput formControlName="title" required [disabled]="loading">
        </mat-form-field>

        <div class="my-2">
          <label class="font-weight-bold mb-1">{{ "generic.description" | translate }} *</label>
          <app-rich-text-editor
            class="full-width"
            formControlName="description"
            required
            [disabled]="loading"
            placeholder="{{ 'components.decision-table.new-decision-table.compile-proposal.placeholders.insert-description' | translate }}">
          </app-rich-text-editor>
        </div>

        <div class="my-2" [formGroup]="addInvitationPageForm.get('customs')">
          <mat-checkbox formControlName="numberPhoneIsMandatory" [disabled]="loading">
            {{ "components.decision-table.show-decision-table.number-phone-is-mandatory" | translate }}
          </mat-checkbox>
        </div>

        <div class="my-2" [formGroup]="addInvitationPageForm.get('customs')">
          <mat-checkbox formControlName="enableThankYouPage" [disabled]="loading">
            {{ "components.decision-table.show-decision-table.enable-thank-you-page" | translate }}
          </mat-checkbox>
        </div>

        @if (addInvitationPageForm.get('customs.enableThankYouPage').value) {
          <div [formGroup]="addInvitationPageForm.get('customs')" class="my-2">
            <label class="font-weight-bold mb-1">{{ "components.decision-table.show-decision-table.thank-you-page" | translate }} *</label>
            <app-rich-text-editor
              class="full-width"
              formControlName="thankYouPage"
              required
              [disabled]="loading"
              placeholder="{{ 'components.decision-table.new-decision-table.compile-proposal.placeholders.insert-thank-you-page' | translate }}">
            </app-rich-text-editor>
          </div>
        }


        <div class="row justify-content-center my-3">
          <button mat-stroked-button class="text-dark-purple border-purple mx-2" (click)="closeDialogue()" [disabled]="loading">
            {{ 'generic.buttons.cancel-and-back' | translate }}
          </button>
          @if (data.invitation_page_id) {
            <button mat-raised-button color="warn" class="mx-2" [disabled]="loading" (click)="deleteInvitationPage()">
              {{ 'components.decision-table.show-decision-table.delete-invitation-page' | translate }}
            </button>
          }
          <button mat-raised-button color="primary" class="mx-2" [disabled]="loading || addInvitationPageForm.invalid" type="submit">
            @if (editMode) {
              <span>{{ 'generic.update' | translate }}</span>
            }
            @if (!editMode) {
              <span>{{ 'generic.send' | translate }}</span>
            }
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>
